module.exports = __webpack_public_path__ + "static/img/enso.552bf1d4.png";